<script setup>
import { inject, ref } from "vue";
import { router } from "@inertiajs/vue3";
import { useToastStore } from "@/stores/toast.js";
import { useModalogStore } from "@/stores/modalog";
import BrandConfirmModalog from "@/Components/Modalogs/BrandConfirmModalog.vue";

const route = inject("route");
const modalogStore = useModalogStore();
const toastStore = useToastStore();

const props = defineProps({
    list: {
        type: Object,
        required: true,
    },
});

const removing = ref(false);

const removeWishListImage = () => {
    removing.value = true;

    axios
        .delete(
            route("giftlists.delete_masthead_photo", {
                giftlist: props.list.uuid,
            }),
        )
        .then(() => {
            modalogStore.closeModalog();
            toastStore.success("Your list's cover photo was removed.");
            router.reload();
        })
        .finally(() => {
            removing.value = false;
        });
};
</script>

<template>
    <BrandConfirmModalog
        title="Remove Current Header Photo?"
        confirm-label="Remove Photo"
        busy-label="Removing Photo"
        danger
        :busy="removing"
        @confirm="removeWishListImage"
    >
        <p>
            Your header photo makes your user profile more personal. Do you
            really want to remove it?
        </p>
    </BrandConfirmModalog>
</template>
